import { EXPERIMENTS, createFormView, useExperiments, useConfig } from '@wix/form-fields';
import { useMemo } from 'react';
export const useFormView = (form, stepId, breakpoint)=>{
    const { isMobile } = useConfig();
    const experiments = useExperiments();
    const useFieldsV2App = experiments.isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2);
    const useFieldsV2Standalone = experiments.isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2_STANDALONE);
    return useMemo(()=>{
        return (form?.steps || []).filter((step)=>!stepId || stepId === step.id).map((step)=>{
            return createFormView({
                form,
                stepId: step.id,
                isMobile,
                breakpoint,
                useFieldsV2: useFieldsV2App || useFieldsV2Standalone
            });
        });
    }, [
        form,
        stepId,
        isMobile,
        breakpoint,
        useFieldsV2App,
        useFieldsV2Standalone
    ]);
};

//# sourceMappingURL=use-form-view.js.map